<template>
  <div class="home">
    <div class="top">
    </div>
      <div class="details">
        <div style="width: 90%;margin-left: 5%;padding-top: 80px">
          <div style="display: flex">
            <div class="title">新闻详情</div>
            <el-button style="height: 50px;margin-top: 40px;margin-left: 80%;background-color: #bfbfbf" @click="back()">返 回</el-button>
          </div>
          <div style="display: flex">
            <div class="name">NEWS</div>
            <div style="width: 70%">
              <el-divider></el-divider>
            </div>
          </div>
          <div ref="html" v-html="value" class="video-container"></div>
          <div style="padding-top: 20px" v-if="fileList.length>0">
            附件：
            <div v-for="item in fileList" :key="item.id" @click="download(item)" style="cursor: pointer;">{{item.fileName}}</div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import {getArticle} from "@/api/article";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "details",
  data(){
    return{
      value:undefined,
      fileList:[]
    }
  },
  watch:{
    value:{
      handler(){
        this.$nextTick(()=>{
          let videoContainer=document.querySelector('.video-container');
          let video=videoContainer.getElementsByTagName('video')
          for (let i = 0; i <video.length ; i++) {
            video[i].style.maxWidth='100%';
            video[i].style.height='auto'
          }
        })

      },
    }
  },
  mounted() {
      getArticle({id:this.$route.query.id}).then(res=>{
        this.value= res.data.content
        this.fileList=res.data.attachments
      })

    },
  methods:{
    async  download(item){
      try {
        const response = await fetch(item.fileUrl);
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = item.fileName;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(downloadUrl);
        link.remove();
      } catch (error) {
        console.error('下载文件时发生错误:', error);
      }
    },
    back(){
      this.$router.push('/')
    },
  }
}
</script>

<style scoped>
.video-container {
  /*display: flex; !* 使用Flex布局 *!*/
  /*justify-content: center; !* 水平居中 *!*/
  /*align-items: center; !* 垂直居中 *!*/
  /*height: 100vh; !* 设置容器高度，根据需要调整 *!*/
  width: 100%;
  text-align: center; /* 对于不支持Flex的浏览器做备选方案 */
}
.video-container video {
  max-width: 100%; /* 确保视频宽度不超过容器宽度 */
  height: auto; /* 保持视频的宽高比 */
  text-align: center;
}
.details{
  width: 70%;
  background-color: white;
  margin-left: 15%;
}
.home{
  width: 100%;
  background-color: #efefef;
}
.title {
  margin-top: 30px;
  height: 50px;
  width: 120px;
  font-weight: 700;
  font-size: 24px;
  color: white;
  background-color: #234C9C;
  display: flex;
  align-items: center;
  justify-content: center;
}
.name{
  font-family: 'Arial Normal', 'Arial', sans-serif;
  font-weight: 400;
  font-style: normal;
  width: 30%;
  color: #AAAAAA;
  font-size: 24px;
  margin-top: 10px;
}
.video{
  width: 100%;
  height: auto;
}
</style>
